import React from 'react'
import "../Orbit.scss"
import FeedbackBlock from '../../../../partials/FeedbackBlock/index.js'
import HTMLContent from '../../../../partials/HTMLContent'
import Button, { ButtonsHolder } from '../../../../partials/Button'

const WrapUp = (props) => {

    const { questionsAnswers, conclusions, onComplete } = props

    return (
        <div className="wrapup-container">
            <div className="analysis-results">
                <FeedbackBlock status="default">
                    {questionsAnswers.map((question, index) => (
                        <div key={index} className="response-container">
                            <strong key={index}>{question.label}:</strong>
                            {question.answers.map((answer, index) => (
                                <div key={`asnwr_${index}`}>{ answer.option }</div>
                            ))}
                        </div>

                    ))}
                </FeedbackBlock>
            </div>

            <div className="conclusions">
                <HTMLContent html={conclusions} />
                <ButtonsHolder orientation="right">
                    <Button text="continue" onClick={onComplete} />
                </ButtonsHolder>
            </div>
        </div>
    );
}

export default WrapUp